import sopClassDictionary from '../util/sopClassDictionary';

/**
 * Checks whether dicom files with specified SOP Class UID have image data
 * @param {string} SOPClassUID - SOP Class UID to be checked
 * @returns {boolean} - true if it has image data
 */

// faltan el resto de modalidades como MR (por ejemplo)
export default function is3dImage(SOPClassUID) {
  return SOPClassUID === sopClassDictionary.CTImageStorage
  || SOPClassUID === sopClassDictionary.EnhancedCTImageStorage
  || SOPClassUID === sopClassDictionary.OphthalmicTomographyImageStorage
  || SOPClassUID === sopClassDictionary.IntravascularOpticalCoherenceTomographyImageStorageForPresentation
  || SOPClassUID === sopClassDictionary.IntravascularOpticalCoherenceTomographyImageStorageForProcessing
  || SOPClassUID === sopClassDictionary.NuclearMedicineImageStorage
  || SOPClassUID === sopClassDictionary.MRImageStorage
  || SOPClassUID === sopClassDictionary.EnhancedMRImageStorage
  || SOPClassUID === sopClassDictionary.EnhancedMRColorImageStorage
  || SOPClassUID === sopClassDictionary.LegacyConvertedEnhancedMRImageStorage
  || SOPClassUID === sopClassDictionary.NuclearMedicineImageStorage
  || SOPClassUID === sopClassDictionary.PositronEmissionTomographyImageStorage;
}
